import { Link } from 'react-router-dom';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { Box, GridProps, GridSize, PaperProps, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { RouteSource } from '@monorepo/shared/src/graph/schema-generated-types-educator';
import ButtonStyledLink from 'components/common/ButtonStyledLink';
import HomeGridCard from './HomeGridCard';

const t = (key: string, options?) => translate('home', key, options);

type Props = {
  xs: GridSize;
  paperProps?: PaperProps;
  gridProps?: GridProps;
};

const StoryBooks: React.FC<Props> = ({ xs, paperProps, gridProps }) => {
  const classes = useStyles();
  const linkInSentence = (
    <Link className={classes.buttonLike} to="/classroom-books">
      <Typography variant="subtitle1" color="primary">
        {t('classroomBooks')}
      </Typography>
    </Link>
  );
  return (
    <HomeGridCard
      xs={xs}
      paperProps={paperProps}
      boxProps={{ justifyContent: 'space-evenly', margin: '0 12px 12px' }}
      {...gridProps}
    >
      <Box className={classes.content}>
        <Typography variant="h2" style={{ fontWeight: 'bold' }}>
          {t('bookTitle')}
        </Typography>
        <Typography
          className={classes.linkText}
          variant="subtitle1"
          style={{ display: 'inline-flex' }}
        >
          {linkInSentence} {t('chooseGreatAlphabetSentence')}
        </Typography>
      </Box>
      <Box display="flex" flexWrap="wrap" className={classes.buttonContent}>
        <ButtonStyledLink
          to="/teachers-guide"
          from={RouteSource.DASHBOARD}
          className={classes.link}
        >
          <Typography className={classes.text} variant="subtitle1">
            {t('teachersGuide')}
          </Typography>
        </ButtonStyledLink>
        <ButtonStyledLink to="/letter-books" from={RouteSource.DASHBOARD} className={classes.link}>
          <Typography className={classes.text} variant="subtitle1">
            {t('letterBooks')}
          </Typography>
        </ButtonStyledLink>
        <ButtonStyledLink
          to="/student-practice-book"
          from={RouteSource.DASHBOARD}
          className={classes.link}
        >
          <Typography className={classes.text} variant="subtitle1">
            {t('studentPracticeBook')}
          </Typography>
        </ButtonStyledLink>
      </Box>
    </HomeGridCard>
  );
};

const useStyles = makeStyles((theme) => ({
  buttonLike: {
    margin: '0px 10px',
    color: theme.palette.primary.main,
  },
  link: {
    marginRight: '20px',
  },
  linkText: {
    '& a': {
      margin: 0,
      marginRight: 3,
    },
  },
  iconClass: {
    margin: '0px 10px',
  },
  text: {
    paddingTop: 3,
  },
  content: {
    margin: 12,
  },
  buttonContent: {
    margin: '12px',
  },
}));

export default StoryBooks;
